import styled from 'styled-components/macro';
import * as React from 'react';
import * as theme from 'lib/style/theme';
import { CheckboxInput } from 'lib/components/inputs/CheckboxInput';
import { Viewer } from 'lib/api/recipients/types';
import { Spinner } from 'lib/components';
import { useVideoViewersNotify } from 'lib/api/videos/useVideoViewersQuery';
import { Tooltip } from 'react-covideo-common';
import { useTranslation } from 'react-i18next';

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15px;
`;

type Props = {
  videoId: string;
  viewer: Viewer;
  showTooltip?: boolean;
};

const extendStyles = {
  popup: {
    maxWidth: '165px',
    left: '50%',
    lineHeight: '24px',
    textAlign: 'left',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },
} as { popup: React.CSSProperties };

export const CheckboxInputNotify = (props: Props) => {
  const { t } = useTranslation();
  const { videoId, viewer, showTooltip = false } = props;
  const [checked, setChecked] = React.useState(
    viewer.shortUrl?.notifyUser || false
  );
  const { mutateAsync, isLoading: loading } = useVideoViewersNotify();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.currentTarget.checked;
    setChecked(isChecked);
    mutateAsync({ videoId, recipientId: viewer.receiverId, notify: isChecked });
  };

  if (showTooltip) {
    return (
      <Tooltip
        extendStyles={extendStyles}
        position={'top'}
        hoverable={true}
        popup={t('You will be notified when this recipient views this video.')}
      >
        <CheckboxWrapper>
          {loading ? (
            <Spinner color={theme.palette.themeDark} size={10} thickness={2} />
          ) : (
            <CheckboxInput
              checked={checked}
              onChange={(e: any) => handleChange(e)}
            />
          )}
        </CheckboxWrapper>
      </Tooltip>
    );
  }
  return (
    <CheckboxWrapper>
      {loading ? (
        <Spinner color={theme.palette.themeDark} size={10} thickness={2} />
      ) : (
        <CheckboxInput
          checked={checked}
          onChange={(e: any) => handleChange(e)}
        />
      )}
    </CheckboxWrapper>
  );
};
